export default "__VITE_ASSET__Dv3Bs5QP__"